module.exports = __webpack_public_path__ + "static/media/Pic-0207.5b5718b0.jpg";